import customizeProNameArr from '@customizeProMixins/proNameArr'
import customizePro from '@customizeProMixins/getCustomizePro'

let customizeInd = 0
for (let i = 0; i < customizeProNameArr.length; i++) {
  const proItem = customizeProNameArr[i]
  if (proItem === customizePro) {
    customizeInd = i
  }
}

export default customizeInd
